import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { scrollToPurchase } from '../utils/scroll';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (href) return; // Let normal link behavior happen if href is provided
    if (onClick) {
      onClick();
    } else {
      scrollToPurchase(e);
    }
  };
  const baseClasses = 'group relative inline-flex items-center justify-center gap-2 rounded-lg bg-brand-green px-8 py-4 text-lg font-bold text-brand-black transition-all hover:bg-brand-greenHover hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(37,211,102,0.3)] hover:shadow-[0_0_30px_rgba(37,211,102,0.5)]';
  const widthClass = fullWidth ? 'w-full' : '';
  if (href) {
    return <a href={href} className={`${baseClasses} ${widthClass} ${className}`} data-id="element-33">
        {children}
        <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-34" />
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${widthClass} ${className}`} aria-label="Ir a la sección de compra" data-id="element-35">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-36" />
    </button>;
}